import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2bd17e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-wrapper" }
const _hoisted_2 = { key: 0 }

import { useRouter } from 'vue-router'
import { ref } from 'vue'

import IconButton from '@/popup/components/shared/IconButton.vue'
import NetworkSwitchWrapper from '@/popup/components/shared/NetworkSwitchWrapper.vue'
import AppIdenticon from '@/popup/components/shared/AppIdenticon/AppIdenticon.vue'
import ChangepasswordSuccess from '@/popup/components/Modal/ChangePasswordSuccess.vue'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { InternalMethods } from '@/shared/apis/messages'
import { saveLastState } from '@/popup/storage/Database'
import { useAppStore } from '@/popup/store/AppStore'
import { useNotifications } from '@/popup/compositions/useNotifications'
import { DBNotifications } from '@/shared/apis/bgnotifications'
import { ToastType } from '@/shared/models/AppNotification'
import { t } from '@/popup/lib/i18n'
import { logError } from '@/shared/logger'
import getUniqueId from '@/shared/getUniqueId'
import ModalTransition from '@/popup/components/shared/Modal/ModalTransition.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordFrame',
  setup(__props) {

const router = useRouter()
const globals = useGlobals()
const appStore = useAppStore()
const notification = useNotifications()

const modalOpen = ref(false)

const openModal = () => {
  modalOpen.value = true
}

const closeModal = () => {
  modalOpen.value = false
}

const existingPassword = ref(
  appStore.lastPopupState?.changePassword?.existingPassword ?? ''
)

const changeExistingPassword = async (existing: string, password: string) => {
  existingPassword.value = existing
  await saveLastState({
    path: router.currentRoute.value.path,
    changePassword: {
      existingPassword: existing,
      newPassword: password,
    },
  })
  router.push({
    path: '/settings/password/change/confirm-password',
    query: { password },
  })
}
const confirmPassword = async (newPassword: string) => {
  try {
    await saveLastState({
      path: router.currentRoute.value.path,
      changePassword: { existingPassword: existingPassword.value, newPassword },
    })
    await globals.sendMessage({
      method: InternalMethods.CHANGE_PASSWORD,
      payload: { currentPassword: existingPassword.value, newPassword },
    })
    openModal()
  } catch (error) {
    logError('Error while confirming password during password change:', error)
    router.push('/')
    notification.updateToast({
      id: getUniqueId(),
      method: DBNotifications.NOTIFICATION,
      profileAddress: '',
      message: t('settings.password.change_failure'),
      type: ToastType.ERROR,
      system: true,
      isPersistent: false,
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AppIdenticon),
      _createVNode(IconButton, {
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/settings'))),
        class: "mt-5"
      }),
      _createElementVNode("div", null, [
        _createVNode(ModalTransition, null, {
          default: _withCtx(() => [
            (modalOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _withDirectives(_createVNode(ChangepasswordSuccess, { "on-cancel": closeModal }, null, 512 /* NEED_PATCH */), [
                      [_vShow, modalOpen.value]
                    ])
                  ]))
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_router_view, {
          onChangePassword: changeExistingPassword,
          onConfirmChangePassword: confirmPassword
        })
      ])
    ]),
    _createVNode(NetworkSwitchWrapper)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})